import { createApp } from 'vue'
import App from './App.vue'
// import store from "../store/embed"
import Vue3NativeNotification from "vue3-native-notification";

import { createStore } from "vuex"
import embed from "../store/modules/embed";
import createPersistedState from "vuex-persistedstate";

function resolveEmbedId() {
  const params = new URLSearchParams(window.location.search);
  const queryEmbedId = params.get("id");

  if (queryEmbedId) {
    return queryEmbedId;
  }

  const pathMatch = window.location.pathname.match(/^\/embed\/([^/]+)$/);
  return pathMatch ? decodeURIComponent(pathMatch[1]) : null;
}

let embedId = resolveEmbedId();

const store = createStore({
  modules: {
    embed
  },
  plugins: [createPersistedState({
    key: 'kairoE-' + embedId
  })],
});

import './main.css'

const app = createApp(App);

app.use(store);
app.use(Vue3NativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true,
});

app.mount('#app');
